/* eslint-disable @typescript-eslint/no-non-null-assertion, react/no-deprecated */
import cx from 'clsx';
import * as React from 'react';

import * as style from './styles/toggle.css';

export interface IToggleProps extends React.HTMLProps<HTMLInputElement> {
  defaultChecked?: boolean;
  defaultDisabled?: boolean;
}

export interface IToggleState {
  isChecked: boolean;
  isDisabled: boolean;
}

export class Toggle extends React.PureComponent<IToggleProps, IToggleState> {
  public static defaultProps: Partial<IToggleProps> = {
    defaultChecked: false,
    defaultDisabled: false,
  };
  public state = {
    isChecked: this.props.defaultChecked!,
    isDisabled: this.props.defaultDisabled!,
  };

  private onChange = (ev: React.FormEvent<HTMLInputElement>) => {
    if (this.props.checked === undefined) {
      this.setState({ isChecked: !this.state.isChecked });
    }
    if (this.props.onChange) {
      this.props.onChange(ev);
    }
  };

  public UNSAFE_componentWillReceiveProps(nextProps: IToggleProps) {
    if (nextProps.checked !== this.state.isChecked && nextProps.checked !== undefined) {
      this.setState({ isChecked: nextProps.checked });
    }
    if (nextProps.disabled !== this.state.isDisabled && nextProps.disabled !== undefined) {
      this.setState({ isDisabled: nextProps.disabled });
    }
  }

  public render() {
    const { className } = this.props;
    const { isChecked, isDisabled } = this.state;

    return (
      <div
        className={cx(
          style['toggle_wrapper'],
          className,
          isChecked && style['toggle_wrapper_checked'],
          isDisabled && style['toggle_wrapper_disabled'],
        )}
      >
        <div className={style['toggle_trace']}>
          <div className={style['toggle_slider']} />
        </div>
        <input className={style['toggle_checkox']} type="checkbox" checked={isChecked} onChange={this.onChange} />
      </div>
    );
  }
}
